import React, { useState, useEffect, useMemo } from 'react';
import UniversalDataSender from '@/components/UniversalDataSender';
import { cn } from '@/lib/utils';
import { actionBarTabType } from '@/types';

interface ActionBarProps {
  selectAll: boolean;
  isIndeterminate: boolean;
  onUpdateSelectAll: (value: boolean) => void;
  selectedMetrics: Record<string, boolean>;
  tabType: actionBarTabType;
  fundData?: any;
  className?: string;
  isFixed?: boolean;
}

const ActionBar: React.FC<ActionBarProps> = ({
  selectAll,
  isIndeterminate,
  onUpdateSelectAll,
  selectedMetrics,
  tabType,
  fundData,
  className,
  isFixed
}) => {
  const [currentSelectAll, setCurrentSelectAll] = useState(false);
  console.log(isIndeterminate, 'isIndeterminate');

  const btnDisabled = useMemo(() => {
    return !selectAll && !isIndeterminate;
  }, [selectAll, isIndeterminate]);

  useEffect(() => {
    setCurrentSelectAll(selectAll);
  }, [selectAll]);

  const handleSelectAllChange = (checked: boolean) => {
    setCurrentSelectAll(checked);
    onUpdateSelectAll(checked);
  };

  const handleSendComplete = (success: boolean) => {
    if (success) {
      console.log('数据发送成功');
    } else {
      console.error('数据发送失败');
    }
  };

  const handleExport = () => {
    console.log('数据导出完成');
  };

  return (
    <div
      className={cn(
        `bottom-0 left-0 right-0 z-[11] rounded-lg px-4 ${isFixed ? 'fixed' : 'absolute'}`,
        className
      )}
    >
      <div>
        <div className="flex items-center justify-between bg-white p-3">
          <div className="flex items-center gap-2">
            <div className={`custom-checkbox ${isIndeterminate ? 'indeterminate' : ''}`}>
              <input
                type="checkbox"
                checked={currentSelectAll}
                onChange={e => handleSelectAllChange(e.target.checked)}
                className="h-4 w-4"
                ref={input => {
                  if (input) {
                    input.indeterminate = isIndeterminate;
                  }
                }}
                id="customcheckbox1"
              />
              <label htmlFor="customcheckbox1" />
            </div>
            <span className="text-sm text-[#1F1F1F]">全选</span>
          </div>
          <UniversalDataSender
            selectedMetrics={selectedMetrics}
            onSendComplete={handleSendComplete}
            onExport={handleExport}
            disabled={btnDisabled}
            tabType={tabType}
            fundData={fundData}
          />
        </div>
      </div>
    </div>
  );
};

export default ActionBar;
